module.exports = __webpack_public_path__ + "static/noun_Independent Child_1578737-8918d7c16c6c45f37389efff835dc76f.svg";